import { post } from "../network/index.js";
import { get } from "../network/index.js";
//获取账号下所有的店铺
const queryStoreInfoByAccountId = (data) => {
  return post("/mercWebi/busStoreInfo/queryStoreInfoByAccountId", data);
};
//获取商家下所有的店铺
const queryStoreInfoTabList = () => {
  return post('/mercWebi/busStoreInfo/queryStoreInfoTabList')
}
//查询商品类目
const listGoodsCategoryByParam = (data) => {
  return post("/mercWebi/busGoodsInfo/listGoodsCategoryByParam", data);
};
// 查询商品分组 不分页
const listGoodsSubareaInfoByParam = (data) => {
  return post(
    "/mercWebi/busGoodsSubareaInfo/listGoodsSubareaInfoByParam",data);
};

// 查询全部商品类型分组 不分页
const queryAllOrderTypeList = (data) => {
  return get(
    "/mercWebi/mercInfo/queryList",data);
};

// 查询当前商家商品类型分组 不分页
const getMercId = (data) => {
  return get(
    "/mercWebi/mercInfo/getMercId",data);
};

// 修改分组
const modifyGoodsSubarea = (data) => {
  return post("/mercWebi/busGoodsSubareaInfo/modifyGoodsSubarea", data);
};
// 商品分组 新增
const insertGoodsSubarea = (data) => {
  return post("/mercWebi/busGoodsSubareaInfo/insertGoodsSubarea", data);
};
// 商品分组 删除
const deleteGoodsSubarea = (data) => {
  return post("/mercWebi/busGoodsSubareaInfo/deleteGoodsSubarea", data);
};
// 商品分组 排序
const modifyGoodsSubareaSort = (data) => {
  return post("/mercWebi/busGoodsSubareaInfo/modifyGoodsSubareaSort", data);
};

// 查询分组内商品 不分页
const listGoodsInfoByParam = (data) => {
  return post("/mercWebi/busGoodsInfo/listGoodsInfoByParam", data);
};
// 商品图片 排序
const modifyGoodsPic = (data) => {
  return post("/mercWebi/busGoodsInfo/modifyGoodsPic", data);
};
// 商品信息
const modifyGoodsOther = (data) => {
  return post("/mercWebi/busGoodsInfo/modifyGoodsOther", data);
};

// 分组内商品 排序
const modifyGoodsSort = (data) => {
  return post("/mercWebi/busGoodsInfo/modifyGoodsSort", data);
};
// 查询分组内商品统计信息
const countGroupInfo = (data) => {
  return post("/mercWebi/busGoodsInfo/countGroupInfo", data);
};
// 查询分组商品详情
const listGoodsInfoById = (data) => {
  return post("/mercWebi/busGoodsInfo/listGoodsInfoById", data);
};
// 查询分组商品规格详情
const listGoodsSpecList = (data) => {
  return post("/mercWebi/busGoodsInfo/listGoodsSpecList", data);
};
// 克隆商品
const cloneGoodsInfo = (data) => {
  return post("/mercWebi/busGoodsInfo/cloneGoodsInfo", data);
};
// 商品上下架
const modifyGoodsStatus = (data) => {
  return post("/mercWebi/busGoodsInfo/modifyGoodsStatus", data);
};
// 商品上售罄
const sellOutgGoods = (data) => {
  return post("/mercWebi/busGoodsInfo/sellOutgGoods", data);
};
// 商品更新
const modifyGoods = (data) => {
  return post("/mercWebi/busGoodsInfo/modifyGoods", data);
};
// 商品上架
const insertGoods = (data) => {
  return post("/mercWebi/busGoodsInfo/insertGoods", data);
};
export default {
  queryStoreInfoByAccountId,
  queryStoreInfoTabList,
  listGoodsCategoryByParam,
  modifyGoodsSubarea,
  listGoodsSubareaInfoByParam,
  queryAllOrderTypeList,
  getMercId,
  modifyGoodsSubareaSort,
  listGoodsInfoById,
  listGoodsInfoByParam,
  countGroupInfo,
  modifyGoodsSort,
  cloneGoodsInfo,
  modifyGoodsStatus,
  sellOutgGoods,
  insertGoodsSubarea,
  deleteGoodsSubarea,
  modifyGoods,
  insertGoods,
  modifyGoodsPic,
  listGoodsSpecList,
  modifyGoodsOther,
};
